import KunLoading16 from './src/index'

KunLoading16.install = function (Vue) {
	Vue.component(KunLoading16.name, KunLoading16);
}

export default KunLoading16;
